import http from './http'

export function getCategories() {
  return http.get('category').then((res) => res.data)
}

export function createCategory(data) {
  return http.post('category', data).then((res) => res.data)
}

export function updateCategory(id, data) {
  return http.put(`category/${id}`, data).then((res) => res.data)
}

export function deleteCategory(id) {
  return http.delete(`category/${id}`).then((res) => res.data)
}
